import { FunctionComponent } from "react";
import { ReactComponent as IconKraftLeft } from "@Icons/kraft/kraft-left.svg";
import { ReactComponent as IconKraftRight } from "@Icons/kraft/kraft-right.svg";
import { Section } from "@Types/pagify";
import "./style.scss";

export const SeoTitle: FunctionComponent<{
  section: Section;
}> = ({ section }) => {
  return (
    <div className="SeoTitle">
      <IconKraftLeft />
      <h1 className="SeoTitle-text">{section.title}</h1>
      <IconKraftRight />
    </div>
  );
};
